var _Circle, _Mask, _G;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Circle, Mask, G, Rect, Path } from "react-native-svg";
var SvgDisconnect = function SvgDisconnect(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _Circle || (_Circle = /*#__PURE__*/React.createElement(Circle, {
    cx: 30,
    cy: 30,
    r: 28,
    fill: "white",
    stroke: "#F74249",
    strokeWidth: 4
  })), _Mask || (_Mask = /*#__PURE__*/React.createElement(Mask, {
    id: "disconnect-mask0",
    x: 0,
    y: 0,
    width: 60,
    height: 60
  }, /*#__PURE__*/React.createElement(Circle, {
    cx: 30,
    cy: 30,
    r: 28,
    fill: "white",
    stroke: "white",
    strokeWidth: 4
  }))), _G || (_G = /*#__PURE__*/React.createElement(G, {
    mask: "url(#disconnect-mask0)"
  }, /*#__PURE__*/React.createElement(Rect, {
    x: 27,
    y: 13,
    width: 30,
    height: 30,
    rx: 3,
    fill: "#F74249"
  }), /*#__PURE__*/React.createElement(Circle, {
    cx: 42,
    cy: 28,
    r: 11,
    fill: "white"
  }), /*#__PURE__*/React.createElement(Circle, {
    cx: 38,
    cy: 28,
    r: 2,
    fill: "#494949"
  }), /*#__PURE__*/React.createElement(Circle, {
    cx: 46,
    cy: 28,
    r: 2,
    fill: "#494949"
  }), /*#__PURE__*/React.createElement(Path, {
    d: "M11 21h12v5a6 6 0 0 1-12 0v-5ZM13 16a1 1 0 1 1 2 0v5h-2v-5ZM19 16a1 1 0 1 1 2 0v5h-2v-5Z",
    fill: "#494949"
  }), /*#__PURE__*/React.createElement(Path, {
    d: "M17 31v8c0 5.523 4.477 10 10 10h23",
    stroke: "#494949",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement(Circle, {
    cx: 30,
    cy: 30,
    r: 28,
    stroke: "#F74249",
    strokeWidth: 4
  }))));
};
export default SvgDisconnect;